import React, { useState } from 'react';
import Header from '../components/header/Header'
import Footer from '../components/footer/Footer'

import dataMontono from '../assets/fake-data/data-montono';
import Action from '../components/layouts/Action';
import { Link } from 'react-router-dom';
import img1 from '../assets/images/que-hacer/casa.jpg';
import img2 from '../assets/images/que-hacer/teatro.jpg';
import img3 from '../assets/images/que-hacer/milanesa.jpg';
import img4 from '../assets/images/que-hacer/cadillal.png';
import img5 from '../assets/images/que-hacer/tafi-viejo.jpeg';
import img6 from '../assets/images/que-hacer/yb.jpg';
import img7 from '../assets/images/que-hacer/botanico.jpeg';
import img8 from '../assets/images/que-hacer/parque.jpg';
import Servicios from '../components/layouts/Servicios';

const QueHacer = () => {
    const [touristOptions] = useState([
        {
            id: 1,
            title: "Visitar la Casa Histórica",
            desc: "Conocé el lugar donde se declaró la Independencia Argentina. Un viaje en el tiempo al corazón de nuestra historia patria.",
            img: img1,
        },
        {
            id: 2,
            title: "Ir al Teatro",
            desc: "Disfrutá de la cartelera del imponente Teatro San Martín o del Teatro Alberdi. Tucumán tiene una enorme movida cultural.",
            img: img2,
        },
        {
            id: 3,
            title: "Comer Sánguche de Milanesa",
            desc: "¡No te podés ir sin probarlo! El verdadero sánguche de milanesa tucumano es una leyenda y el plato típico indiscutido de la provincia.",
            img: img3,
        },
        {
            id: 4,
            title: "El Cadillal",
            desc: "A pocos minutos de la ciudad. Ideal para paseos en barco, aerosillas, deportes acuáticos o simplemente comer con una vista increíble.",
            img: img4,
        },
        {
            id: 5,
            title: "Trekking en Tafí Viejo",
            desc: "Recorré la yunga tucumana por senderos increíbles en Tafí Viejo. Una inmersión total en el verde y la naturaleza exuberante.",
            img: img5,
        },
        {
            id: 6,
            title: "Trekking en Yerba Buena",
            desc: "A solo 20 minutos en colectivo vas a encontrar cerros, sendas y cascadas en Yerba Buena, al pie del Cerro San Javier.",
            img: img6,
        },
        {
            id: 7,
            title: "Jardín Botánico",
            desc: "Un oasis dentro de la ciudad o cerca del pie del cerro para caminar, conocer especies nativas y pasar una tarde tranquila.",
            img: img7,
        },
        {
            id: 8,
            title: "Parque 9 de Julio",
            desc: "El pulmón verde más grande de la capital. Perfecto para caminar, andar en bici, o tomar mates frente a la Casa del Obispo Colombres.",
            img: img8,
        }
    ]);

    return (
        <div className='que-hacer-page'>
            <Header />

            <section className="tf-section best-rooms" style={{ backgroundColor: '#f9f5ec', paddingTop: '150px' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="block-text center mb-50 text-black">
                                <h1 className="heading-bg" data-aos="fade-in" data-aos-duration="1000"><span style={{ WebkitTextFillColor: 'rgba(0,0,0,0.05)', WebkitTextStrokeWidth: '0px' }}>Turismo</span></h1>
                                <h5 className="sub-title mb-10 text-black" data-aos="fade-up" data-aos-duration="1000" style={{ color: '#000' }}>Descubrí Tucumán</h5>
                                <h3 className="title text-black mb-28" data-aos="fade-up" data-aos-duration="1000" style={{ color: '#000' }}>¿Qué hacer en la ciudad?</h3>
                            </div>
                        </div>
                    </div>

                    <div className="row mt-50">
                        {touristOptions.map((item, index) => (
                            <div key={item.id} className="col-12 mb-5" data-aos="fade-up" data-aos-duration="1000">
                                <div className="row align-items-center" style={{ backgroundColor: '#fff', borderRadius: '15px', overflow: 'hidden', boxShadow: '0 5px 15px rgba(0,0,0,0.05)', margin: 0, border: '1px solid #df4421' }}>
                                    <div className={`col-md-6 p-0 ${index % 2 !== 0 ? 'order-md-2' : ''}`}>
                                        <img src={item.img} alt={item.title} style={{ width: '100%', height: '350px', objectFit: 'cover' }} />
                                    </div>
                                    <div className={`col-md-6 p-4 p-md-5 ${index % 2 !== 0 ? 'order-md-1' : ''}`}>
                                        <h3 className="text-black mb-3" style={{ fontSize: '28px', fontWeight: 'bold', color: '#000' }}>
                                            {item.title}
                                        </h3>
                                        <p className="text-black" style={{ fontSize: '18px', lineHeight: '1.6', color: '#000' }}>
                                            {item.desc}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <Servicios data={dataMontono} />
            <Action />
            <Footer />
        </div>
    );
}

export default QueHacer;